export default { sha: '2470c122595c2f27c5db0b4133c395c403c86ef3', buildNumber: 'undefined' }
